export const BUY_REQUEST_GRID_COLUMN = {
    ID: "Id",
    EVENT: "Event",
    VENUE: "Venue",
    EVENT_DATE: "EventDate",
    QUANTITY: "Quantity",
    SECTION: "Section",
    ROW: "Row",
    SEATS: "Seats",
    DELIVERY_METHOD: "DeliveryMethod",
    NTL: "Ntl",
    COST_PER_TICKETS: "CostPerTicket",
    WAITING: "Waiting",
    BUY_MANAGER: "BuyManager",
    MANAGE: "Manage"
}